module.exports = __webpack_public_path__ + "static/media/trenitalia.46cb29cf.svg";